import "./styles.scss";
import Leaflet from "leaflet";

export const LeafletCustomIcon = Leaflet.divIcon({
  className: "leaflet-custom-icon",
});
